export interface IIcon {
  active: boolean;
}

export const unSelected = "#081C42";
export const selected = "#081C42";
